

<template>
    <div class="container" style="margin-top: 42px;">
      <el-row class="faq-container" style="padding:0 110px 48px 0;">
        <el-col v-for="(faq, index) in faqs" :key="index" :span="12">
          <div class="faq-item" @click="handleClick(faq)">
            <h3 class="show-ellipsis">{{ faq.question }}</h3>
              <div class="faq-answer show-ellipsis">
                 <i>答</i> A: {{ faq.answer }}
              </div>
          </div>
        </el-col>
      </el-row>
    </div>

</template>
<script>

export default {
  props:{
    activeName:{
      type:String
    }
  },
  components: {
 
  },
  created() {
  },
  data() {
    return {
      faqs: [
      {
        id:'1',
        question: '【入仓】为什么货物不能正常入仓？',
        answer: '可能是以下问题之一：1、是到FBA的货物，但外箱没有FBA标签；2、外箱没有九方的运单标签；3、纸箱已经散架；4、下单信息和交货信息有出入；5、货物到仓了却还未下单。'
      },
      {
        id:'2',
        question: '【签约】什么样的物流合同才算是公平公正的合同？',
        answer: '1、把报价表中没有但却很重要的内容都放进去的合同；2、双方把出现最坏情况的权责利都事先约定好的合同。'
      },
      {
        id:'3',
        question: '【签约】物流合同对走包税渠道的重要性？',
        answer: '绝大部分包税货物的提单收货人都不是货主，也就是从交货给物流公司那一刻起货权就已经完全转移到了物流公司。比如货值100万，就相当于你把100万现金给了物流公司，而且连收据都不要一张。'
      },
      {
        id:'4',
        question: '【报价】如何避免隐形收费？',
        answer: '不要追求绝对意义上的“一口价”，跨境物流始终存在一些产生额外费用的概率，只是这些额外费用是可以被事先约定清楚的。'
      },
      {
        id:'5',
        question: '【报价】报价表内容那么多，如何避免掉坑？',
        answer: '除了运费单价，一定要注意看备注信息，重点包括价格有效期，适应的产品品类、计费方式、附加费清单、可能产生的额外费用等。'
      },
      {
        id:'6',
        question: '【报价】如何才能一次性报出准确优惠的价格？',
        answer: '尽量一次性给出完整的货物信息，包括：整票货物的品名、体积、重量、件数、最终派送地址等。货物信息越详尽，报价越快越准。'
      },
      // 其他的FAQ对象...
    ]
    };
  },
  methods: {
    handleClick(item){
      console.log(item,this.activeName,'item,activeName')
      this.$router.push({
        path:'/questionDetail',
        query:{
          id:item.id,
          activeName:this.activeName
        }
      })
    }
  }
  
};
</script>
<style src="../index.css" scoped>


</style>